import React from 'react';
import { Flex, Switch, Typography } from 'antd';
import { Divider } from '@/shared/ui/Divider';
import { Settings } from '@/models/settings';
import styles from './WorkflowSection.module.css';

const { Text } = Typography;

interface WorkflowSectionProps {
  settings: Settings;
  onUpdate: (partial: Partial<Settings>) => void;
}

export const WorkflowSection: React.FC<WorkflowSectionProps> = ({
  settings,
  onUpdate,
}) => (
  <div className={styles.rows}>
    <Flex
      id="show-create-addendum-modal"
      align="center"
      justify="space-between"
      className={styles.row}
    >
      <Flex vertical>
        <Text>Show modal before creating addendum</Text>
        <Text type="secondary" className={styles.hint}>
          When enabled, confirmation details are shown before creating the
          addendum.
        </Text>
      </Flex>
      <Switch
        checked={settings.showAddendumModal}
        onChange={(checked) => onUpdate({ showAddendumModal: checked })}
      />
    </Flex>

    <Divider />

    <Flex
      id="copilot-enabled"
      align="center"
      justify="space-between"
      className={styles.row}
    >
      <Flex vertical>
        <Text>Enable AI Copilot</Text>
        <Text type="secondary" className={styles.hint}>
          Show the AI assistant and its suggestions throughout the app.
        </Text>
      </Flex>
      <Switch
        checked={settings.copilotEnabled}
        onChange={(checked) => onUpdate({ copilotEnabled: checked })}
      />
    </Flex>
  </div>
);
